import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useEffect,
} from 'react';
import dayjs from '../config/dayjs';
import { useTranslation } from 'react-i18next';

type DayjsLocaleContextType = {
  locale: string;
};

const DayjsLocaleContext = createContext<DayjsLocaleContextType | undefined>(
  undefined
);

export const DayjsLocaleProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const {
    i18n: { language },
  } = useTranslation();
  const [locale, setLocale] = useState(dayjs.locale());

  const updateLocale = useCallback((newLocale: string) => {
    dayjs.locale(newLocale);
    setLocale(newLocale);
  }, []);

  useEffect(() => {
    updateLocale(language);
  }, [language]);

  return (
    <DayjsLocaleContext.Provider value={{ locale }}>
      {children}
    </DayjsLocaleContext.Provider>
  );
};

export const useDayjsLocale = () => {
  const context = useContext(DayjsLocaleContext);
  if (context === undefined) {
    throw new Error('useDayjsLocale must be used within a DayjsLocaleProvider');
  }
  return context;
};
